import { useState } from "react";
import { useTran } from "@/hooks";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LANGUAGES, getLanguageByCode } from "@/lib/i18n";
import { chooseLanguage } from "@/lib/i18n/language-session";

export const LanguageSwitcher = () => {
  const { i18n } = useTran();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage = getLanguageByCode(i18n.language) || LANGUAGES[0];

  const handleLanguageChange = (langCode) => {
    // The user's explicit choice (nx.lang.explicit); see language-policy.js.
    void chooseLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex h-8 shrink-0 items-center gap-2 rounded-radius px-2 transition-colors hover:bg-muted"
        >
          <Globe className="h-4 w-4" />
          <span className="hidden md:inline text-sm">
            {currentLanguage.nativeName}
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-48 max-w-[calc(100vw-1rem)]"
      >
        {LANGUAGES.map((language) => (
          <DropdownMenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span>{language.nativeName}</span>
            {i18n.language === language.code && (
              <Check className="h-4 w-4 text-primary" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
